import type { TabType } from '../types/types';

import { FC, useEffect } from 'react';

import { RootState, useAppDispatch } from '@/store/store';
import { useSelector } from 'react-redux';
import { checkUnread } from '@/store/slices/notificationsSlice';

import { BellIcon } from '@heroicons/react/24/outline';

interface INotificationButton {
  setActiveTab: (tab: TabType) => void;
}

const NotificationButton: FC<INotificationButton> = ({ setActiveTab }) => {
  const dispatch = useAppDispatch();

  const unreadCount = useSelector(
    (state: RootState) => state.notifications.unRead
  );

  useEffect(() => {
    dispatch(checkUnread());

    const interval = setInterval(() => dispatch(checkUnread()), 10000);
    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <button
      className="flex items-center w-full p-2 mt-2 rounded-md hover:bg-gray-100 cursor-pointer"
      onClick={() => setActiveTab('notification')}>
      <div className="relative mr-3">
        {unreadCount > 0 && (
          <span className="absolute -left-1 -top-2 inline-flex items-center font-bold justify-center w-[18px] h-[16px] bg-red-500 text-white text-xs rounded-full">
            {unreadCount}
          </span>
        )}
        <BellIcon className="size-5 text-gray-600" />
      </div>
      Meddelelser
    </button>
  );
};

export default NotificationButton;
